export default __webpack_public_path__ + "static/media/feather-menu.9a061893.svg";